module.exports = __webpack_public_path__ + "img/4-5.26fa2921.png";